var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { key: _vm.updateKey, attrs: { id: "app" } },
    [
      _c("navigation", { attrs: { "is-authenticated": _vm.isAuthenticated } }),
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "keep-alive",
            { attrs: { include: _vm.keepAliveInclude } },
            [_c("router-view")],
            1
          ),
          _c("site-footer"),
        ],
        1
      ),
      !_vm.isGdprAccepted ? _c("gdpr-notification") : _vm._e(),
      _c("slideshow-ctrl"),
      _c("search-overlay"),
      _c("back-to-top"),
      _vm.isAuthenticated
        ? _c("modal-terms-of-service", {
            ref: "modalTermsOfService",
            attrs: { show: _vm.showModalTermsOfService, "accept-button": true },
            on: {
              accept: _vm.onAcceptTermsOfService,
              close: function ($event) {
                _vm.showModalTermsOfService = false
              },
            },
          })
        : _vm._e(),
      _vm.isAuthenticated ? _c("modal-unsaved-changes") : _vm._e(),
      _vm.isAuthenticated ? _c("modal-save-pending") : _vm._e(),
      _vm.error
        ? _c("modal-error-message", {
            attrs: { error: _vm.error },
            on: {
              close: function ($event) {
                _vm.error = null
              },
            },
          })
        : _vm._e(),
      !_vm.isAuthenticated ? _c("modal-login-required") : _vm._e(),
      !_vm.isAuthenticated ? _c("modal-login-expired") : _vm._e(),
      !_vm.isAuthenticated
        ? _c("anon-login-prompt", { ref: "anonLoginPrompt" })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }